import request from "../services/HTTPClient";
import { requestMethods, API } from "../constants";

// --- FUNCIÓN DE ACTUALIZACIÓN UNIFICADA (CORREGIDA) ---
// Utiliza la constante correcta y espera un solo objeto de datos
function UpdateUser(data) {
  return request({
    url: API.USER.SUPPLIER.UPDATE, // Apunta a 'users/update'
    method: requestMethods.POST,      // Usamos POST para máxima compatibilidad
    data: data,
  });
}

function All(request_body) {
  return request({
    url: API.USER.USERS.concat("/", request_body.role),
    method: requestMethods.GET,
  });
}

function GetUsersByRoles(roles) {
  return request({
    url: API.USER.GET_BY_ROLES,
    method: requestMethods.POST,
    data: { roles }
  });
}

function GetUserSelectors() {
    return request({
        url: API.USER.SELECTOR,
        method: requestMethods.GET,
    });
}

function UpdateProfile(request_body) {
  return request({
    url: API.USER.UPDATE_PROFILE, 
    method: requestMethods.PATCH,
    data: 
      {
        id: request_body.id,
        description: request_body.description
      }
  });
}

function Change_User(request_body) {
  return request({
    url: API.USER.CHANGE_USER,
    method: requestMethods.POST,
    data: {
      id: request_body.value,
      value: request_body.value,
    },
  });
}

function NewUser(request_body) {
  return request({
    url: API.USER.NEW_USER,
    method: requestMethods.POST,
    data: {
      organization_id: request_body.organization_id,
      name: request_body.name,
      colony_id: request_body.colony_id,
      street: request_body.street,
      internal_number: request_body.internal_number,
      external_number: request_body.external_number,
      type: request_body.type,
      status: request_body.status,
    },
  });
}

function NewUserRequest(request_body) {
  return request({
    url: API.USER.NEW_USER_REQUEST,
    method: requestMethods.POST,
    data: {
      user_id: request_body.user_id,
      role: request_body.role,
      response: request_body.response,
      email: request_body.email,
    },
  });
}

function UserRole() {
  return request({
    url: API.USER.ROLE,
    method: requestMethods.GET,
  });
}

function UpdownUser(request_body) {
  return request({
    url: API.USER.UPDOWN_USER,
    method: requestMethods.POST,
    data: {
      id: request_body.id,
      checked: request_body.checked,
    },
  });
}

function solicitudSoftware(request_body) {
  return request({
    url: API.USER.SOLICITUD_SOFTWARE,
    method: requestMethods.POST,
    data: {
      request: request_body,
    },
  });
}

function GetNewUserRequest() {
  return request({
    url: API.USER.GET_USER_REQUEST,
    method: requestMethods.GET,
  });
}

function GetAllSuppliers() {
  return request({
    url: API.USER.SUPPLIER.GET_ALL,
    method: requestMethods.GET,
  });
}

function RegisterAdmin(data) {
  return request({
    url: API.AUTH.REGISTER_ADMIN,
    method: requestMethods.POST,
    data: data
  });
}

function GetAll(params = {}) {
  const { limit, lastVisible, search } = params;
  let url = API.USER.ALL;
  
  const queryParams = [];
  if (limit) queryParams.push(`limit=${limit}`);
  if (lastVisible) queryParams.push(`lastVisible=${encodeURIComponent(lastVisible)}`);
  if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
  
  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }
  
  return request({
    url: url,
    method: requestMethods.GET,
  });
}

function GetClientsAdmin(params = {}) {
  const { role, limit, lastVisible, search } = params;
  let url = API.USER.CLIENTS_ADMIN;
  
  const queryParams = [];
  if (role) queryParams.push(`role=${role}`);
  if (limit) queryParams.push(`limit=${limit}`);
  if (lastVisible) queryParams.push(`lastVisible=${encodeURIComponent(lastVisible)}`);
  if (search) queryParams.push(`search=${encodeURIComponent(search)}`);
  
  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }
  
  return request({
    url: url,
    method: requestMethods.GET,
  });
}

function GetUserById(data) {
  return request({
    url: API.USER.GET_USER_BY_ID,
    method: requestMethods.POST,
    data: data
  });
}

function UpdateStatus(data) {
  return request({
    url: API.USER.UPDATE_STATUS,
    method: requestMethods.POST,
    data: data
  });
}

function SaveToken(data) {
  return request({
    url: API.USER.SAVE_TOKEN,
    method: requestMethods.POST,
    data: data
  });
}

function ChangeLogo(data) {
  return request({
    url: API.USER.CHANGE_LOGO,
    method: requestMethods.POST,
    data: data
  });
}

// --- FUNCIÓN NUEVA PARA CAMBIAR EL BANNER ---
function ChangeBanner(data) {
  // Reutilizamos la lógica de subida de archivos, pero apuntando a un endpoint de API diferente.
  // Necesitarás crear este endpoint en tu backend y definir la constante API.USER.CHANGE_BANNER
  return request({
    url: API.USER.CHANGE_BANNER, 
    method: requestMethods.POST,
    data: data
  });
}

function GetVs() {
  return request({
    url: API.USER.GET_VS,
    method: requestMethods.GET,
  });
}

function UploadFiscal(data) {
  return request({
    url: API.USER.UPLOAD_FISCAL,
    method: requestMethods.POST,
    data: data
  });
}

function Delete(id) {
  return request({
    url: API.USER.DELETE.concat(id),
    method: requestMethods.DELETE,
  });
}

function GetClients(params = {}) {
  const { buyerId, sellerId } = params;
  let url = API.USER.CLIENTS;

  const queryParams = [];
  if (buyerId) queryParams.push(`buyerId=${buyerId}`);
  if (sellerId) queryParams.push(`sellerId=${sellerId}`);

  if (queryParams.length > 0) {
    url += `?${queryParams.join('&')}`;
  }

  return request({
    url: url,
    method: requestMethods.GET,
  });
}

function GetClientsByBuyer(buyerId) {
  return request({
    url: `${API.USER.CLIENTS}?buyerId=${buyerId}`,
    method: requestMethods.GET,
  });
}

function GetClientsBySeller(sellerId) {
  return request({
    url: `${API.USER.CLIENTS}?sellerId=${sellerId}`,
    method: requestMethods.GET,
  });
}

function GetAssignedPersonnel(clientId) {
  return request({
    url: API.USER.ASSIGNED_PERSONNEL.replace(':clientId', clientId),
    method: requestMethods.GET,
  });
}

function AssignClientsToPersonnel(data) {
  return request({
    url: API.USER.ASSIGN_CLIENTS,
    method: requestMethods.PATCH,
    data: data
  });
}

function GetSupplierInfo(userId) {
  return request({
    url: API.USER.SUPPLIER.GET_CATEGORIES.replace(':id', userId),
    method: requestMethods.GET,
  });
}

const UserService = {
  All,
  GetUsersByRoles,
  GetUserSelectors,
  Delete,
  Change_User,
  NewUser,
  NewUserRequest,
  UserRole,
  UpdownUser,
  solicitudSoftware,
  GetNewUserRequest,
  UpdateUser,
  RegisterAdmin,
  GetUserById,
  GetAll,
  GetClientsAdmin,
  UpdateStatus,
  SaveToken,
  ChangeLogo,
  ChangeBanner,
  UploadFiscal,
  GetAllSuppliers,
  GetVs,
  GetClients,
  GetClientsByBuyer,
  GetClientsBySeller,
  GetAssignedPersonnel,
  AssignClientsToPersonnel,
  GetSupplierInfo
};

export default UserService;
